import { render, staticRenderFns } from "./peopleTypeDialogDelay.vue?vue&type=template&id=2682cac2&scoped=true&lang=pug&"
import script from "./peopleTypeDialogDelay.vue?vue&type=script&lang=js&"
export * from "./peopleTypeDialogDelay.vue?vue&type=script&lang=js&"
import style0 from "./peopleTypeDialogDelay.vue?vue&type=style&index=0&id=2682cac2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2682cac2",
  null
  
)

export default component.exports